import { Route, Routes } from 'react-router-dom';
import CommunicationHome from './communicationHome';

const OptedInRoute = () => {

    return (
        <Routes>
            <Route path='/:request/:lang' element={<CommunicationHome />} />
            <Route path='/:request' element={<CommunicationHome />} />
        </Routes>
    );
};

export default OptedInRoute;


